//hooks
import useFetch from "hooks/useFetch"

//constatns
import { ENDPOINTS } from "constants/endpoints"

//providers
import { useAppContext } from "providers/app"
import { useUsersDataContext } from "../providers/users"

function useChangePassword(closeWindow) {
    const app = useAppContext()
    const users = useUsersDataContext()

    const { fetch, loading, validations, handleValidations } = useFetch()
    function handleSubmit(e) {
        e.preventDefault()
        const data = new FormData(e.target)

        fetch({ endpoint: 'auth/admin-change-password', method: 'post', data })
            .then(() => {
                users.refetchData()
                app
                    .handleMessage()
                    .success()
                    .show(`Паролата беше сменена успешно!`)
                closeWindow()
            })
    }

    return {
        handleSubmit,
        loading,
        validations,
        handleValidations
    }
}

export default useChangePassword